import { Link } from 'react-router-dom'
import { siteInfo, navLinks } from '@/mocks/siteInfo'
import { categories } from '@/mocks/categories'

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-star-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">快速导航</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">分类浏览</h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                <span>每日 9:00 - 22:00</span>
              </li>
              <li>
                <Link to="/about" className="inline-flex items-center gap-1 text-primary-400 hover:text-primary-300 transition-colors cursor-pointer">
                  了解更多 <i className="ri-arrow-right-line"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 版权所有。
          </p>
          <div className="flex items-center gap-6 text-sm text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  )
}